/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ApiRootLinkRel, ApiRootResource, ApiRootService } from '@common/api-root-shared';
import {
  ApiResourceService,
  createSingleResourceActions,
  ResourceRepository,
  ResourceServiceConfig,
  SingleResourceReducer,
  SingleResourceState,
  StateService,
} from '@common/tech-shared';
import { Action, ActionReducerMap } from '@ngrx/store';
import { ConfigurationResource } from './configuration.model';

export const CONFIGURATION_FEATURE_KEY = 'ConfigurationState';

export const CONFIGURATION_PATH = 'configuration';

export interface ConfigurationParentState {
  [CONFIGURATION_PATH]: SingleResourceState;
}

export class ConfigurationResourceService extends ApiResourceService<ApiRootResource, ConfigurationResource> {}

export function createConfigurationResourceService(
  apiRootService: ApiRootService,
  stateService: StateService,
  repository: ResourceRepository,
) {
  return new ApiResourceService(buildConfig(apiRootService), stateService, repository);
}

function buildConfig(apiRootService: ApiRootService): ResourceServiceConfig<ApiRootResource> {
  return {
    stateInfo: { name: CONFIGURATION_FEATURE_KEY, path: CONFIGURATION_PATH },
    baseResource: apiRootService.getApiRoot(),
    getLinkRel: ApiRootLinkRel.CONFIGURATION,
  };
}

function configurationResourceReducer(state: SingleResourceState, action: Action) {
  const resourceReducer: SingleResourceReducer = new SingleResourceReducer(
    createSingleResourceActions({ name: CONFIGURATION_FEATURE_KEY, path: CONFIGURATION_PATH }),
  );
  return resourceReducer.reducer(state, action);
}

export const configurationReducer: ActionReducerMap<ConfigurationParentState> = {
  [CONFIGURATION_PATH]: configurationResourceReducer,
};
